/**
 * Dependencies.
 */
import de from './de';
import en from './en';
import es from './es';
import it from './it';
import pt from './pt';

/**
 * Export translations.
 */
export default {
  'de-DE': { MAIN: de },
  'en-US': { MAIN: en },
  'es-ES': { MAIN: es },
  'it-IT': { MAIN: it },
  'pt-PT': { MAIN: pt }
};
